/*
  Rychlý nákup z produktové karty (Kočenda, IV. konzultace 18. 8.).
  Sdílí ho homepage i výpisy kolekcí. Karta je <a>, takže všechny kliky
  uvnitř .prod-card__sizes zastavujeme, aby neproklikly na produkt.
*/
(function () {
  'use strict';

  function msgEl(wrap) { return wrap.querySelector('.prod-card__sizes-msg'); }

  function say(wrap, text, keep) {
    var el = msgEl(wrap);
    if (!el) return;
    el.textContent = text;
    if (!keep) setTimeout(function () { el.textContent = ''; }, 2200);
  }

  function refreshCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.classList.remove('hidden');
        });
      })
      .catch(function () {});
  }

  /* Vyprodaná velikost: stejná hláška i výpočet termínu jako na produktové stránce. */
  function restockNote(wrap) {
    var raw = wrap.getAttribute('data-restock-date') || '';
    var parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
    var prefix = 'Tato velikost je vyprodaná.';
    if (!parts) return prefix;

    var target = new Date(+parts[1], +parts[2] - 1, +parts[3]);
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var days = Math.ceil((target - now) / 86400000);
    if (days <= 0) return prefix + ' Naskladňujeme každým dnem.';
    var weeks = Math.ceil(days / 7);
    if (weeks <= 1) return prefix + ' Naskladníme ji do týdne.';
    var unit = weeks >= 5 ? 'týdnů' : 'týdny';
    return prefix + ' Naskladníme ji za ' + (weeks - 1) + '–' + weeks + ' ' + unit + '.';
  }

  /* Malé potvrzení v rohu (snippets/arche-cart-toast.liquid). */
  var toastTimer = null;

  function showToast(item) {
    var t = document.querySelector('[data-arche-toast]');
    if (!t || !item) return false;

    var img = t.querySelector('.arche-toast__img');
    if (item.image) {
      img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_112x140_crop_center$1$2');
      img.alt = item.product_title || '';
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    t.querySelector('.arche-toast__name').textContent = item.product_title || item.title || '';

    /* Barva je u jednobarevného kusu šum — zajímá velikost (u setu obě). */
    var meta = '';
    if (item.options_with_values && item.options_with_values.length) {
      meta = item.options_with_values
        .filter(function (o) {
          var n = (o.name || '').toLowerCase();
          return n.indexOf('barva') === -1 && n.indexOf('color') === -1;
        })
        .map(function (o) {
          var n = (o.name || '').toLowerCase();
          /* Stejné zkratky jako na kartě — plné názvy dílů setu jsou na potvrzení moc dlouhé. */
          if (n.indexOf('crewneck') > -1 || n.indexOf('mikina') > -1) return 'Mikina: ' + o.value;
          if (n.indexOf('t-shirt') > -1 || n.indexOf('tričko') > -1 || n.indexOf('tee') > -1) return 'Tričko: ' + o.value;
          return 'Velikost: ' + o.value;
        })
        .join(' · ');
    }
    if (!meta && item.variant_title) meta = item.variant_title;
    t.querySelector('.arche-toast__meta').textContent = meta;

    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-in'); });

    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
    return true;
  }

  function hideToast() {
    var t = document.querySelector('[data-arche-toast]');
    if (!t) return;
    clearTimeout(toastTimer);
    t.classList.remove('is-in');
    setTimeout(function () { t.hidden = true; }, 340);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-arche-toast-close]')) hideToast();
  });

  /* Kurzor na potvrzení = člověk ho čte, nezavírat mu ho pod rukama. */
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest('[data-arche-toast]')) clearTimeout(toastTimer);
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest('[data-arche-toast]')) {
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hideToast, 2500);
    }
  });

  function addToCart(wrap, variantId) {
    wrap.classList.add('is-busy');
    say(wrap, 'Přidávám…', true);

    var payload = { id: parseInt(variantId, 10), quantity: 1 };
    var submit = wrap.querySelector('.prod-card__size-submit');
    if (submit && submit.dataset.xxlPreorder === 'true') payload.properties = { 'Dodání předobjednávky': '20. 11. 2026' };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (item) {
        wrap.querySelectorAll('.prod-card__size.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
        syncSubmit(wrap);

        /* Potvrzuje widget v rohu; hláška na kartě je záloha, kdyby chyběl.
           „Přidávám…" se musí smazat, jinak zůstane viset pod velikostmi. */
        if (showToast(item)) say(wrap, '');
        else say(wrap, 'Přidáno do košíku ✓');
        return refreshCartCount();
      })
      .catch(function () {
        say(wrap, 'Nepodařilo se přidat');
      })
      .then(function () {
        wrap.classList.remove('is-busy');
      });
  }

  /* Vybraná kombinace se hledá ve vložené mapě variant (set má dvě řady, běžný kus jednu). */
  function findSetVariant(wrap) {
    var chosen = {};
    wrap.querySelectorAll('.prod-card__size.is-picked').forEach(function (c) {
      chosen[c.dataset.optPos] = c.dataset.optValue;
    });
    var rows = wrap.querySelectorAll('.prod-card__size-row');
    if (Object.keys(chosen).length < rows.length) return null;

    var variants;
    try { variants = JSON.parse(wrap.dataset.variants || '[]'); } catch (e) { return null; }

    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var pos in chosen) {
        if (variants[i].o[parseInt(pos, 10) - 1] !== chosen[pos]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  function syncSubmit(wrap) {
    var submit = wrap.querySelector('.prod-card__size-submit');
    if (!submit) return;

    /* Běžný kus: chip nese rovnou id varianty, kombinace se dohledávat nemusí. */
    var picked = wrap.querySelector('.prod-card__size.is-picked[data-variant-id]');
    var variant = picked
      ? { id: picked.dataset.variantId, a: !picked.classList.contains('is-out'), p: picked.dataset.xxlPreorder === 'true' }
      : findSetVariant(wrap);
    if (!variant) {
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = 'Do košíku';
      delete submit.dataset.variantId;
      return;
    }
    if (!variant.a) {
      submit.setAttribute('aria-disabled', 'true');
      submit.textContent = 'Vyprodáno';
      delete submit.dataset.variantId;
      return;
    }
    submit.setAttribute('aria-disabled', 'false');
    submit.dataset.xxlPreorder = variant.p ? 'true' : 'false';
    submit.textContent = variant.p ? 'Předobjednat' : 'Do košíku';
    say(wrap, variant.p && window.ArcheXxlDelivery ? window.ArcheXxlDelivery.text() : '', true);
    submit.dataset.variantId = variant.id;
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('.prod-card__sizes');
    if (!wrap) return;

    /* Karta je odkaz — uvnitř výběru velikosti se na produkt neproklikává. */
    e.preventDefault();
    e.stopPropagation();

    if (wrap.classList.contains('is-busy')) return;

    var submit = e.target.closest('.prod-card__size-submit');
    if (submit) {
      if (submit.getAttribute('aria-disabled') === 'true') return;
      addToCart(wrap, submit.dataset.variantId);
      return;
    }

    var chip = e.target.closest('.prod-card__size');
    if (!chip) return;

    if (chip.classList.contains('is-out')) {
      say(wrap, restockNote(wrap), true);
      clearTimeout(wrap.__outTimer);
      wrap.__outTimer = setTimeout(function () { say(wrap, ''); }, 6000);
      return;
    }

    /* Chip jen vybírá — do košíku se jde vždycky tlačítkem. */
    var row = chip.closest('.prod-card__size-row');
    if (row) {
      row.querySelectorAll('.prod-card__size').forEach(function (c) { c.classList.remove('is-picked'); });
    }
    chip.classList.add('is-picked');
    syncSubmit(wrap);
  });
})();
